
























































import {Component, Vue, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import AppConfig from "@/config/AppConfig";


const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';
const RESOURCE_TIME_TRACKING_STATISTICS: string = '/tt/statistics';

@Component
export default class Settings extends Vue {
  public name: string = "Settings";

  private shortTimeWorkPerDayHours: number = 4;
  private workingHoursPerDay: number = 8;
  private workingDaysInWeek: string = '1-5';
  private hasShortTimeWork: any = 0;

  @Action('fetchUsersConfigs', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) fetchUsersConfigs: any;
  @Action('updateUsersConfigs', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) updateUsersConfigs: any;

  @Getter('getUsersConfigs', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) usersConfigs: any;

  @Watch('usersConfigs', {immediate: true, deep: true})
  private setUsersConfigs() {

    if (this.usersConfigs) {

      this.workingHoursPerDay = this.usersConfigs.hours_per_day ?? this.workingHoursPerDay;
      this.shortTimeWorkPerDayHours = this.usersConfigs.short_time_work_per_day_hours ?? this.shortTimeWorkPerDayHours;
      this.workingDaysInWeek = this.usersConfigs.working_days_in_week ?? this.workingDaysInWeek;
      this.hasShortTimeWork = this.usersConfigs.has_short_time_work ? 1 : 0;

    }

  }

  private get businessDaysCountThisMonth(): number {

    return this.$moment().monthBusinessDays().length;

  }

  private get businessDaysCountThisMonthYet(): number {

    return this.$moment().businessDaysIntoMonth();

  }

  private get isTodayWorkingDay(): boolean {

    // nächster Arbeitstag  return this.$moment('30-01-2015', 'DD-MM-YYYY').nextBusinessDay().format('DD-MM-YYYY');

    return this.$moment().isBusinessDay(); //.format('YYYY-MM-DD HH:mm:ss').isBusinessDay();
  }

  private doFetchUsersConfigs(): void {

    this.fetchUsersConfigs({
      resource: RESOURCE_TIME_TRACKING_STATISTICS + '/users-configs'
    });

  }

  private saveUsersConfigs(): void {

    let configs: any = {

      hours_per_day: this.workingHoursPerDay,
      short_time_work_per_day_hours: this.shortTimeWorkPerDayHours,
      working_days_in_week: this.workingDaysInWeek,
      has_short_time_work: this.hasShortTimeWork,

    };

    this.updateUsersConfigs({
      resource: RESOURCE_TIME_TRACKING_STATISTICS + '/users-configs', data: configs
    });

  }

  created() {

    this.doFetchUsersConfigs();

  }

}
